export function isOcrSeedId(id: string): boolean {
    return id.startsWith("ocr-contact-") || id.startsWith("ocr-address-");
}
